import React from 'react';
import { Box, Typography } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { card_variants } from '../../constant/card';

const TaskCard = ({ task, isInSidebar = false, isInCalendar = false }) => {
    const isOverdue = task.status === 'overdue';
    const isDueSoon = task.status === 'dueSoon';

    // Native drag handlers
    const handleDragStart = (e) => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('taskId', task.id.toString());
        e.dataTransfer.setData('task', JSON.stringify(task));
        e.currentTarget.style.opacity = '0.5';
    };

    const handleDragEnd = (e) => {
        e.currentTarget.style.opacity = '1';
    };

    return (
        <Box
            draggable
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            sx={{
                p: 1.5,
                backgroundColor: isInCalendar ? '#F7F9FA' : '#ffffff',
                borderRadius: 1.5,
                display: 'flex',
                alignItems: 'flex-start',
                // border: isInCalendar ? '2px solid #F2F2F7' : '1px solid #f2f2f7',
                ...isInCalendar ? card_variants.calendar : card_variants.default,
                cursor: 'grab',
                '&:active': {
                    cursor: 'grabbing'
                },
                // '&:hover': {
                //     boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                //     transform: 'translateY(-2px)',
                //     transition: 'all 0.2s'
                // }
            }}
        >

            {/* Drag indicator icon */}
            {/* {isInSidebar && (
                <Box sx={{ mr: 1, pt: 0.5 }}>
                    <DragIndicatorIcon sx={{ color: '#bdbdbd', fontSize: 28, cursor: 'grab' }} />
                </Box>
            )} */}

            <Box sx={{ mr: 1, }}>
                <DragIndicatorIcon sx={{ color: '#bdbdbd', fontSize: 24, cursor: 'grab' }} />
            </Box>

            <Box>

                {/* Project Name */}
                <Typography
                    variant="caption"
                    sx={{
                        color: '#8a8a8a',
                        fontSize: '12px',
                        display: 'block',
                        mb: 0.5
                    }}
                >
                    {task.projectName}
                </Typography>

                {/* Task Name */}
                <Typography
                    // variant="body2"
                    fontWeight={500}
                    sx={{
                        color: '#3a3a3a',
                        mb: 1,
                        fontSize: '14px',
                        fontWeight: 500
                    }}
                >
                    {task.taskName}
                </Typography>

                {/* Deliverable Value */}
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.primary',
                        fontSize: '14px',
                        fontWeight: 400,
                        display: 'block',
                        mb: 1
                    }}
                >
                    {task.deliverableValue}
                </Typography>

                {/* Due Date */}
                <Box display="flex" flexDirection="column" alignItems="flex-start" gap={0.5}>
                    {/* <Typography
                        variant="caption"
                        sx={{
                            color: '#3a3a3a',
                            fontSize: '10px',
                            fontWeight: 500,
                        }}
                    >
                        Due date
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            color: isOverdue || isDueSoon ? '#EF4444' : '#1F2937',
                            fontSize: '10px',
                            fontWeight: 500
                        }}
                    >
                        • {task.dueDate}
                    </Typography> */}

                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: '10px',
                            fontWeight: 500,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                color: (isOverdue || isDueSoon) ? '#eb5757' : '#F3BF3A', // Red for overdue/due soon, primary yellow otherwise
                                fontWeight: 700,
                                mr: 0.5,
                            }}
                        >
                            •
                        </Box>
                        <Box
                            component="span"
                            sx={{
                                color: (isOverdue || isDueSoon) ? '#eb5757' : '#3a3a3a', // Red for overdue/due soon, black otherwise
                                fontWeight: 500,
                            }}
                        >
                            {task.dueDate}
                        </Box>
                    </Typography>

                </Box>
            </Box>
        </Box>
    );
};

export default TaskCard;